import {
  makeRequest,
  constructUrlParams,
  formatDateParam,
} from "../lib/makeRequest";

export const branch_category_overall_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.covered_date) };
  return makeRequest("/branch-categories/overall", params);
};

export const branch_category_cluster_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.covered_date) };
  return makeRequest(`/branch-categories/cluster/${data.clusterId}`, params);
};

export const branch_category_area_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.covered_date) };
  return makeRequest(`/branch-categories/area/${data.areaId}`, params);
};

export const branch_category_branch_v4 = (data) => {
  const urlParams = new URLSearchParams();

  if (data.isRange) {
    urlParams.append("from", formatDateParam(data.dates.from));
    urlParams.append("to", formatDateParam(data.dates.to));
  } else {
    urlParams.append("coveredDate", formatDateParam(data.covered_date));
  }

  return makeRequest(
    `/branch-categories/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
